import * as React from 'react';
import MarginOfSafetyModal from './financials/MarginOfSafetyModal';

function EstimatedValuation({data} :any) {
  function recommendationClass(decision_color) {
    if (decision_color == 'red') {
      return 'badge-danger badge-pill'
    } else if (decision_color == 'green') {
      return 'badge-success badge-pill'
    } else {
      return 'badge-info badge-pill'
    }
  }

  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Margin of Safety Valuation</h4>
          <p className="card-description">< MarginOfSafetyModal message="Estimated valuation at a 15% minimum expected rate of return for the next 10 years." /></p>
          <div className="table-responsive">
            <table className="table table-striped">
              <tbody>
                <tr>
                  <td>Growth rate (%)</td>
                  <td>{ (data.estimated_valuation?.decision === 'Unpredictable') ? 'Unpredictable' : data.estimated_valuation?.valuation?.eps_growth_rate }</td>
                </tr>
                <tr>
                  <td>Future price (10 years est.)</td>
                  <td>{ (data.estimated_valuation?.decision === 'Unpredictable') ? 'Undetermined' : data.estimated_valuation?.future_market_price_in_words }</td>
                </tr>
                <tr>
                  <td>Market price</td>
                  <td>
                    <span className={ recommendationClass(data.estimated_valuation?.decision_color) }>
                      {data.estimated_valuation?.price_in_words}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Fair value</td>
                  <td>{ (data.estimated_valuation?.decision === 'Unpredictable') ? 'Undetermined' : data.estimated_valuation?.sticker_price_in_words }</td>
                </tr>
                <tr>
                  <td>Margin of safety</td>
                  <td>
                    <span className={ 'badge-success badge-pill'  }>
                      { (data.estimated_valuation?.decision === 'Unpredictable') ? 'Undetermined' : data.estimated_valuation?.margin_of_safety_in_words }
                    </span>
                   </td>
                </tr>
                <tr>
                  <td>Decision</td>
                  <td>
                    <span className={ (data.estimated_valuation?.decision_color == 'green') ? 'badge-success badge-pill' : 'badge-danger badge-pill' }>
                      {data.estimated_valuation?.decision}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EstimatedValuation;
